<div class="m-t10 flex-row-container">    
    <div class="flex-row-container">        
        <div class="font16 m-lr15 flex-col-container">
            <span class="gray-text">Plan Start</span>
            <span class="font16 B">{{appliedPlan && appliedPlan.startYr?appliedPlan.startYr:'-'}}</span>
        </div>
        <div class="font16 m-lr15 flex-col-container">
            <span class="gray-text">Plan End</span>
            <span class="font16 B">{{appliedPlan && appliedPlan.endYr?appliedPlan.endYr:'-'}}</span>
        </div>
        <div class="font16 m-lr15 flex-col-container">
            <span class="gray-text">Median Portfolio Starting Balance</span>
            <span class="font20 B">{{nCFAdditionalOutput && nCFAdditionalOutput.portBeginBal>=0?(nCFAdditionalOutput.portBeginBal | currency:'USD': 'symbol' : '1.0-0'):'-'}}</span>
        </div>
        <div class="font16 m-lr15 flex-col-container">
            <span class="gray-text">Median Portfolio Ending Balance</span>
            <span class="font20 B">{{nCFAdditionalOutput && nCFAdditionalOutput.portEndBal>=0?(nCFAdditionalOutput.portEndBal | currency:'USD': 'symbol' : '1.0-0'):'-'}}</span>
        </div>
        
    </div>
    <div class="flex-1 flex-row-center">
        <mat-form-field class="ip-center font20" style="width:110px;">
            <input matInput  type="number" [formControl]="year" 
            placeholder="Year" 
            aria-label="Year" 
            maxlength="4"  
            [min]="appliedPlan && appliedPlan.startYr?appliedPlan.startYr:''"
            [max]="appliedPlan && appliedPlan.endYr?appliedPlan.endYr:''"
            style="font-size: 30px;"
            NumbersOnly/>
            <mat-hint align="end">{{yearHint}}</mat-hint>
        </mat-form-field>
        <div class="m-t20 m-l20 font16">
            <a mat-button class="pointer" style="color: var(--neutralPrimary);" (click)="setYearValueBy('PLANSTART')">At Plan Start</a>
            <span *ngIf="nCFAdditionalOutput && nCFAdditionalOutput.c1RetYear" class="p-lr5">|</span>
            <a *ngIf="nCFAdditionalOutput && nCFAdditionalOutput.c1RetYear" mat-button class="pointer" style="color: var(--neutralPrimary);" (click)="setYearValueBy('C1RET')">Retirement Year for Client</a>
            <span *ngIf="nCFAdditionalOutput && nCFAdditionalOutput.c2RetYear"  class="p-lr5">|</span>
            <a *ngIf="nCFAdditionalOutput && nCFAdditionalOutput.c2RetYear" mat-button class="pointer" style="color: var(--neutralPrimary);" (click)="setYearValueBy('C2RET')">Retirement Year for Spouse</a>
            <span class="p-lr5">|</span>
            <a mat-button class="pointer" style="color: var(--neutralPrimary);" (click)="setYearValueBy('PLANEND')">At Plan End</a>
        </div>      
    </div>
    <!-- <gp-pvfv-setting></gp-pvfv-setting> -->
</div>
<!-- <gp-chart-loading-animation *ngIf="!isDataAvailable" class="flex-col-center m-t100"></gp-chart-loading-animation> -->
<div  *ngIf="!isDataAvailable" class="flex-col-center m-t75">       
    <gp-chart-loading-animation></gp-chart-loading-animation>
</div>
<highcharts-chart  *ngIf="isDataAvailable"
    [Highcharts] = "Highcharts"
    [callbackFunction]="chartCallBack" 
    [options]="options"  
    style="width: 100%; height: 87%; display: block;">
</highcharts-chart>            

